export const Categories = {
  Spazzatura: -1,
  InElaborazione: 0,
  FattureAttive: 1,
  FatturePassive: 2,
  AltriDocumentiContabili: 3,
  UnicoPF: 4,
  UnicoSP: 5,
  UnicoSC: 6,
  Modello730: 7,
  ModelloIva: 8,
  Deleghe: 9,
  Spesometro: 10,
  AltriDichiarazioniFiscali: 11,
  Cedolini: 12,
  PraticheLavoro: 13,
  DichiarazioniFiscali: 14,
  PraticheCamerali: 15,
  AttiSocietari: 16,
  AttiPrivati: 17,
  FattureAttiveElettroniche: 18, // FATTURA_ATTIVA_AGYO
  FatturePassiveElettroniche: 19, // FATTURA_PASSIVA_AGYO
  FattureElettronicheGeneriche: 20,
  WORKING_IN_PROGRESS_PRO: 1000,
  REJECTED_PRO: 1001,
  UNCLASSIFIED_PRO: 1002
};

export const MacroCategoriesSorting = ["inbox", "fatture", "documenti contabili", "fiscale", "gestione personale", "altra documentazione"];

export const MacroCategoriesTitles = {
  "documenti contabili": "Azienda",
  "gestione personale": "Personale",
  "altra documentazione": "Altri"
};

export const TypeCategoriesIcons = [
  { type: "Allegati dichiarazioni 730", icon: "paperclip" },
  { type: "Allegati dichiarazioni 730 precompilato", icon: "paperclip" },
  { type: "Allegati dichiarazioni IRAP", icon: "paperclip" },
  { type: "Allegati dichiarazioni modello unico/redditi", icon: "paperclip" },
  { type: "Messaggi PEC", icon: "envelope" },
  { type: "Messaggi mail ordinaria", icon: "envelope" },
  { type: "Impegno alla trasmissione telematica", icon: "desktop" },
  { type: "Incarico per addebito telematico", icon: "desktop" },
  { type: "Ricevute da presentazioni telematiche", icon: "desktop" },
  { type: "Documenti privacy (GDPR)", icon: "shield" },
  { type: "Informativa-consenso privacy", icon: "shield" },
  { type: "Log (registrazioni informatiche)", icon: "file-code" },
  { type: "Non specificato", icon: "file-alt" },
  { type: "Documenti per la firma digitale", icon: "file-signature" },
  { type: "Documenti per la firma elettronica avanzata (FEA)", icon: "file-signature" },
  { type: "Atti privati", icon: "file-certificate" },
  { type: "Atti pubblica amministrazione", icon: "file-certificate" },
  { type: "Atti societari", icon: "file-certificate" },
  { type: "Pratiche Camerali", icon: "file-certificate" },
  { type: "Contratti", icon: "handshake-alt" },
  { type: "Contratti Pubblica Amministrazione", icon: "handshake-alt" },
  { type: "Registro lettere di intento", icon: "handshake-alt" },
  { type: "Cedolini", icon: "user-tie" },
  { type: "Pratiche del lavoro", icon: "user-tie" },
  { type: "Libro unico del lavoro (LUL)", icon: "book-user" },
  { type: "Libri sociali", icon: "book" },
  { type: "Libro cespiti", icon: "book" },
  { type: "Libro giornale", icon: "book" },
  { type: "Libro inventari", icon: "book" },
  { type: "Libro mastro (schede o partitari contabili)", icon: "book" },
  { type: "Schede cespiti", icon: "book" },
  { type: "Bilancio d'esercizio", icon: "book-open" },
  { type: "Registri iva", icon: "book-open" },
  { type: "Registro cronologico", icon: "book-open" },
  { type: "Registro di protocollo informatico", icon: "book-open" },
  { type: "Registro incassi e pagamenti professionisti", icon: "book-open" },
  { type: "Altri registri", icon: "book-open" },
  { type: "Giornale di magazzino", icon: "warehouse" },
  { type: "Dichiarazione RED", icon: "file-invoice" },
  { type: "Dichiarazione dell'imposta di bollo assolta in modo virtuale", icon: "file-invoice" },
  { type: "Dichiarazione modelli INV.CIV", icon: "file-invoice" },
  { type: "Dichiarazione sostitutiva unica (DSU) isee", icon: "file-invoice" },
  { type: "Dichiarazioni 730", icon: "file-invoice" },
  { type: "Dichiarazioni 730 precompilato", icon: "file-invoice" },
  { type: "Dichiarazioni 730/4", icon: "file-invoice" },
  { type: "Dichiarazioni 770 ordinario", icon: "file-invoice" },
  { type: "Dichiarazioni 770 semplificato", icon: "file-invoice" },
  { type: "Dichiarazioni IMU - tasi", icon: "file-invoice" },
  { type: "Dichiarazioni IRAP", icon: "file-invoice" },
  { type: "Dichiarazioni consolidato nazionale e mondiale", icon: "file-invoice" },
  { type: "Dichiarazioni fiscali", icon: "file-invoice" },
  { type: "Dichiarazioni iva", icon: "file-invoice" },
  { type: "Dichiarazioni iva 26", icon: "file-invoice" },
  { type: "Dichiarazioni iva 74 bis", icon: "file-invoice" },
  { type: "Dichiarazioni unico/redditi enti non commerciali", icon: "file-invoice" },
  { type: "Dichiarazioni unico/redditi persone fisiche", icon: "file-invoice" },
  { type: "Dichiarazioni unico/redditi societa di capitali", icon: "file-invoice" },
  { type: "Dichiarazioni unico/redditi societa di persone", icon: "file-invoice" },
  { type: "Modelli F23", icon: "file-spreadsheet" },
  { type: "Modelli F24", icon: "file-spreadsheet" },
  { type: "Quietanze versamenti (F24, F23, rli, ecc.)", icon: "file-spreadsheet" },
  { type: "Modello crediti iva tr", icon: "file-invoice" },
  { type: "Certificazione unica", icon: "file-invoice" },
  { type: "Istanze di rimborso IRAP", icon: "file-invoice" },
  { type: "Liquidazioni periodiche iva", icon: "file-invoice" },
  { type: "Altre dichiarazioni", icon: "file-invoice" },
  { type: "Domanda iscrizione 5 per Mille", icon: "file-invoice" },
  { type: "Prospetto delle liquidazioni periodiche dell'iva", icon: "file-invoice" },
  { type: "Scheda destinazione 8xMille, 5xMille, 2xMille", icon: "file-invoice" },
  { type: "Scheda destinazione 8xMille", icon: "file-invoice" },
  { type: "5xMille", icon: "file-invoice" },
  { type: "2xMille", icon: "file-invoice" },
  { type: "Spesometro", icon: "file-invoice" },
  { type: "Studi di settore", icon: "file-invoice" },
  { type: "Dichiarazione di intento", icon: "file-invoice" },
  { type: "Lettere di intento emesse e ricevute", icon: "file-invoice" },
  { type: "Intrastat (elenchi riepilogativi degli scambi intracomunitari)", icon: "file-invoice" },
  { type: "Comunicazione annuale dati iva", icon: "file-contract" },
  { type: "Comunicazione beni d'impresa", icon: "file-contract" },
  { type: "Comunicazione modelli AA5/AA6", icon: "file-contract" },
  { type: "Comunicazione modelli AA7/AA9", icon: "file-contract" },
  { type: "Comunicazione polivalente (spesometro, black list, repubblica san marino)", icon: "file-contract" },
  { type: "Altre comunicazioni", icon: "file-contract" },
  { type: "Fascicoli informatici", icon: "folder-open" },
  { type: "Fatture PA-Privati (SDI) emesse", icon: "file-invoice-dollar" },
  { type: "Fatture PA-Privati (SDI) emesse in nome e per conto", icon: "file-invoice-dollar" },
  { type: "Fatture PA-Privati (SDI) ricevute", icon: "file-invoice-dollar" },
  { type: "Fatture emesse B2B", icon: "file-invoice-dollar" },
  { type: "Fatture ricevute B2B", icon: "file-invoice-dollar" },
  { type: "DDT emessi", icon: "file-invoice-dollar" },
  { type: "DDT ricevuti", icon: "file-invoice-dollar" },
  { type: "Bolle emesse", icon: "file-invoice-dollar" },
  { type: "Bolle ricevute", icon: "file-invoice-dollar" },
  { type: "Dati fatture emesse e ricevute", icon: "file-invoice-dollar" },
  { type: "Preventivi-Offerte", icon: "file-invoice-dollar" },
  { type: "Lotto fatture PA-Privati (SDI) emesse", icon: "file-invoice-dollar" },
  { type: "Lotto fatture PA-Privati (SDI) ricevute", icon: "file-invoice-dollar" },
  { type: "Lotto fatture emesse B2B", icon: "file-invoice-dollar" },
  { type: "Lotto fatture ricevute B2B", icon: "file-invoice-dollar" },
  { type: "Note di variazione emesse B2B", icon: "file-invoice-dollar" },
  { type: "Note di variazione ricevute B2B", icon: "file-invoice-dollar" },
  { type: "Notifiche fatture PA-Privati (SDI)", icon: "envelope-open-dollar" },
  { type: "Scontrini/ricevute fiscali/incassi", icon: "receipt" },
  { type: "Note spese e relativi giustificativi", icon: "receipt" },
  { type: "Gestione deleghe/revoche accesso a fatture e corrispettivi", icon: "file-user" }
];

export const MacroCategoriesIcons = {
  inbox: "inbox",
  azienda: "building",
  fiscale: "file-invoice",
  fatture: "file-invoice-dollar",
  "gestione del personale": "user-tie",
  "altra documentazione": "file-alt"
};
